import styles from "./VirksomhetsKort.module.less";
import { Heading } from "@digipost/dds-heading-react";
import { scaledLogoUri } from "../infrastructure/logo/scaledLogo";
import { Organisasjonsnummer } from "../Organisasjonsnummer/Organisasjonsnummer";

interface VirksomhetsKortProps {
  navn: string;
  orgNr: string;
  logoUri?: string;
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  headingSize?: "xsmall" | "small" | "medium" | "large";
  onClickHandler?: (s: string) => void;
}

export function VirksomhetsKort({
  navn,
  orgNr,
  logoUri,
  headingLevel,
  onClickHandler,
}: VirksomhetsKortProps) {
  const content = (
    <>
      {logoUri && <img src={scaledLogoUri(logoUri, 250, 100)} alt="" />}
      <div className={styles.textContainer}>
        <Heading level={headingLevel || 2} size={"medium"}>
          {navn}
        </Heading>
        <Organisasjonsnummer orgNr={orgNr} />
      </div>
    </>
  );

  if (!onClickHandler) {
    return <div className={styles.virksomhetsKort}>{content}</div>;
  }

  return (
    <button
      className={`${styles.virksomhetsKort} ${styles.virksomhetsKortHoverable}`}
      onClick={() => onClickHandler(orgNr)}
    >
      {content}
    </button>
  );
}
